var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        { ref: "sheetForm", attrs: { model: _vm.sheetForm } },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _vm.operationType !== "view"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onConfirmSheet },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.confirm")))]
                  )
                : _vm._e(),
              _c("el-button", { on: { click: _vm.onCancel } }, [
                _vm._v(_vm._s(_vm.$t("common.cancel"))),
              ]),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "sortableTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.sheetForm.tableData,
                border: "",
                "row-key": "id",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "processCode",
                  label: "制成编码",
                  "min-width": "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "processName",
                  label: "制成名称",
                  "min-width": "180",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "factorCode",
                  label: "指标编码",
                  "min-width": "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "factorName",
                  label: "指标名称",
                  "min-width": "180",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sheetName",
                  label: "Sheet Name",
                  "min-width": "180",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "tableData." + scope.$index + ".sheetName",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.operationType == "view" },
                              model: {
                                value: scope.row.sheetName,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "sheetName", $$v)
                                },
                                expression: "scope.row.sheetName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sheetIndex",
                  label: "Sheet Index",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "tableData." + scope.$index + ".sheetIndex",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.operationType == "view" },
                              model: {
                                value: scope.row.sheetIndex,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "sheetIndex", $$v)
                                },
                                expression: "scope.row.sheetIndex",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }